import React from 'react';
import { Iterable } from 'immutable';

/**
 * Inspects properties of the wrapped component for immutable JS
 *   types and converts those properties to JS objects.  This is
 *   useful if you are selecting data from the redux store, which
 *   is stores and presents data in immutableJS.
 * @param {React.Component} WrappedComponent
 */
export default (WrappedComponent) => (wrappedComponentProps) => {
  const propsJS = Object.entries(wrappedComponentProps).reduce(
    (newProps, [key, value]) => (
      { ...newProps,
        [key]: Iterable.isIterable(value)
          ? value.toJS()
          : value }),
    {}
  );

  return <WrappedComponent {...propsJS} />;
};

